import { render, staticRenderFns } from "./AuditComp.vue?vue&type=template&id=07c12420"
import script from "./AuditComp.vue?vue&type=script&lang=js"
export * from "./AuditComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports